// src/api/users.api.js
import axiosInstance from './axiosInstance';

/**
 * جلب كل المستخدمين
 */
export const fetchUsers = (params = {}) =>
  axiosInstance.get('/users/', { params });

/**
 * إنشاء مستخدم جديد — يدعم FormData لرفع الصورة
 */
export const createUser = (payload) => {
  const isFormData = payload instanceof FormData;
  return axiosInstance.post('/users/', payload, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
  });
};

/**
 * تحديث بيانات مستخدم — يدعم FormData لرفع الصورة
 */
export const updateUser = (id, payload) => {
  const isFormData = payload instanceof FormData;
  return axiosInstance.patch(`/users/${id}/`, payload, {
    headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
  });
};

/**
 * جلب كل الأقسام
 */
export const fetchDepartments = () =>
  axiosInstance.get('/departments/');